type OpenFn = () => Promise<string | null>;

const modalApi: { open: OpenFn | null } = {
    open: null,
};

export function useModalPrompt() {
    return {
        open: (): Promise<string | null> => {
            if (!modalApi.open) throw new Error('ModalPrompt not mounted');
            return modalApi.open();
        },
        registerOpen(fn: OpenFn) {
            modalApi.open = fn;
        },
    };
}
